export default class CustomErrorManager {
  static createCustomError(name, code, message, errorObj) {
    const errorMessage = errorObj ? `${message} : ${errorObj.message}` : message;
    const error = new Error(errorMessage);
    error.name = name;
    error.code = code;
    return error;
  }

  static NotFoundError(code, message, errorObj) {
    return CustomErrorManager.createCustomError("NotFoundError", code, message, errorObj);
  }

  static NotAllowedError(code, message, errorObj) {
    return CustomErrorManager.createCustomError("NotAllowedError", code, message, errorObj);
  }

  static NotReadableError(code, message, errorObj) {
    return CustomErrorManager.createCustomError("NotReadableError", code, message, errorObj);
  }

  static ValidationError(code, message, errorObj) {
    return CustomErrorManager.createCustomError("ValidationError", code, message, errorObj);
  }

  static InValidError(code, message, errorObj) {
    return CustomErrorManager.createCustomError("InValidError", code, message, errorObj);
  }

  static PermissionError(code, message, errorObj) {
    return CustomErrorManager.createCustomError("PermissionError", code, message, errorObj);
  }

  static ServiceError(code, message, errorObj) {
    return CustomErrorManager.createCustomError("ServiceError", code, message, errorObj);
  }
}
